import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationIT from "./it.json";
import translationEN from "./en.json";

const resources = {
  it: {
    translation: translationIT,
  },
  en: {
    translation: translationEN,
  },
};

const browserLanguage = navigator.language || navigator.userLanguage;

const defaultLanguage = browserLanguage.split("-")[0]; 
const supportedLanguages = Object.keys(resources);
const lng = supportedLanguages.includes(defaultLanguage)
  ? defaultLanguage
  : "it";

i18n.use(initReactI18next).init({
  resources,
  lng,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
